import React, { memo } from 'react';
import cls from './ApplicationSettingsNavigation.module.scss';
import { NavLink } from 'react-router-dom';
import routes from '../../../routes';

const ApplicationSettingsNavigation = memo(() => {
  return (
    <nav className={cls.Navigation}>
      <NavLink
        to={routes.pages.applicationSettingsPageForPortal()}
        className={({ isActive }) => (isActive ? `${cls.Link} ${cls.ActiveLink}` : cls.Link)}
      >
        Portal
      </NavLink>
      <NavLink
        to={routes.pages.applicationSettingsPageForMobile()}
        className={({ isActive }) => (isActive ? `${cls.Link} ${cls.ActiveLink}` : cls.Link)}
      >
        Mobile
      </NavLink>
      <NavLink
        to={routes.pages.applicationSettingsPageForCommon()}
        className={({ isActive }) => (isActive ? `${cls.Link} ${cls.ActiveLink}` : cls.Link)}
      >
        Common
      </NavLink>
      <NavLink
        to={routes.pages.applicationSettingsPageForAdmin()}
        className={({ isActive }) => (isActive ? `${cls.Link} ${cls.ActiveLink}` : cls.Link)}
      >
        Admin Panel
      </NavLink>
      <NavLink
        to={routes.pages.applicationsReferallSettingsPage()}
        className={({ isActive }) => (isActive ? `${cls.Link} ${cls.ActiveLink}` : cls.Link)}
      >
        Referral
      </NavLink>
    </nav>
  );
});

export default ApplicationSettingsNavigation;
